import { DefaultPageHeader } from 'layouts';
import type { OrganizationDetail } from 'models';
import { Card } from 'ui';
import { useGetOrganizationEntityBreadcrumb } from '../hooks';
import { OrganizationsVideosList } from './organizations-videos-list';

type P = {
  getPathToVideoDetail: (id: string) => string;
  organization: OrganizationDetail;
};

const OrganizationsVideos = ({ getPathToVideoDetail, organization }: P) => {
  const breadcrumbRoutes = useGetOrganizationEntityBreadcrumb({ entityType: 'videos', organization });

  return (
    <>
      <DefaultPageHeader routes={breadcrumbRoutes} title="Videos" />
      <Card>
        <OrganizationsVideosList getPathToVideoDetail={getPathToVideoDetail} organizationId={organization.id} />
      </Card>
    </>
  );
};

export default OrganizationsVideos;
